/**
 * @author TomaszCzura ({}
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import {IconButton} from '@mui/material';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import {Input} from '@material-ui/core';
import i18next from 'i18next';

class ResetPasswordInput extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
    this.handleMouseDownPassword = this.handleMouseDownPassword.bind(this);

    this.state = {
      showPassword: false,
      showPassword2: false,
    };
  }

  handleBlur(e) {
    this.props.validate(e.target.value);
  }

  onChange(e) {
    if (this.props.validate(e.target.value)) {
      this.props.onChange(e);
    }
  }

  handleClickShowPassword(fieldName) {
    if (fieldName === 'password') {
      this.setState({
        showPassword: !this.state.showPassword,
      });
    } else {
      this.setState({
        showPassword2: !this.state.showPassword2,
      });
    }
  };

  handleMouseDownPassword(event) {
    event.preventDefault();
  };

  render() {
    return (
      <div className="form-group">
        <label className="control-label visible-ie8 visible-ie9">{i18next.t('login.password')}</label>
        <div className="input-icon" style={{marginBottom: '5px'}}>
          <i className="fa fa-lock"/>
          <Input
            className="form-control placeholder-no-fix"
            type={this.state.showPassword ? 'text' : 'password'}
            onChange={this.onChange}
            onBlur={this.handleBlur}
            placeholder={i18next.t('login.password')}
            name="password"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => this.handleClickShowPassword('password')}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword ? (
                    <Visibility />
                  ) : (
                    <VisibilityOff />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </div>
        <label className="control-label visible-ie8 visible-ie9">{i18next.t('login.password2')}</label>
        <div className={`input-icon ${this.props.error ? 'has-error' : ''}`}>
          <i className="fa fa-lock"/>
          <Input
            className="form-control placeholder-no-fix"
            type={this.state.showPassword2 ? 'text' : 'password'}
            onChange={this.onChange}
            onBlur={this.handleBlur}
            placeholder={i18next.t('login.password2')}
            name="password2"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword2 ? (
                    <Visibility />
                  ) : (
                    <VisibilityOff />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
          {this.props.error ? (<span className="help-block">{this.props.error}</span>) : null}
          {this.props.success ? (<span className="help-block">{this.props.success}</span>) : null}
        </div>
        <div style={{marginTop: '10px'}}>
          {this.props.success ?
            <button
              type="submit"
              className="btn green pull-left"
              onClick={this.props.backToLoginAction}
            >
              {i18next.t('login.back_to_login')}
            </button> :
            <button
              type="submit"
              className="btn green pull-right"
            >
              {i18next.t('login.confirm_new_password')}
            </button>
          }
        </div>
      </div>
    );
  }
}

ResetPasswordInput.propTypes = {
  success: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  backToLoginAction: PropTypes.func,
  handleBlur: PropTypes.func,
  validate: PropTypes.func,
  password: PropTypes.string,
  password2: PropTypes.string,
};
ResetPasswordInput.defaultProps = {};

export default ResetPasswordInput;
